var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorpagegraphic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 354,
    viewBox: "0 0 500 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8321)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8321",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 500,
    height: 354
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V354H500V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.328 36.3287C137.958 36.3287 140.901 33.3126 140.901 29.5921C140.901 25.8716 137.958 22.8555 134.328 22.8555C130.697 22.8555 127.754 25.8716 127.754 29.5921C127.754 33.3126 130.697 36.3287 134.328 36.3287Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.534 65.8131C420.779 65.8131 425.03 61.4565 425.03 56.0823C425.03 50.7082 420.779 46.3516 415.534 46.3516C410.29 46.3516 406.039 50.7082 406.039 56.0823C406.039 61.4565 410.29 65.8131 415.534 65.8131Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8556 70.0753C14.8467 70.0753 18.0822 66.7596 18.0822 62.6695C18.0822 58.5794 14.8467 55.2637 10.8556 55.2637C6.86439 55.2637 3.62891 58.5794 3.62891 62.6695C3.62891 66.7596 6.86439 70.0753 10.8556 70.0753Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.368 295.182C496.368 291.098 493.138 287.788 489.153 287.788C485.168 287.788 481.938 291.098 481.938 295.182C481.938 299.266 485.168 302.576 489.153 302.576C493.138 302.576 496.368 299.266 496.368 295.182Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.993 330.957C374.293 330.957 378.591 326.553 378.591 321.121C378.591 315.689 374.293 311.285 368.993 311.285C363.692 311.285 359.395 315.689 359.395 321.121C359.395 326.553 363.692 330.957 368.993 330.957Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.376 134.617C85.454 134.617 88.7598 131.907 88.7598 128.563C88.7598 125.22 85.454 122.51 81.376 122.51C77.298 122.51 73.9922 125.22 73.9922 128.563C73.9922 131.907 77.298 134.617 81.376 134.617Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.841 292.843C135.524 287.812 130.477 284.827 125.568 286.176C120.658 287.525 117.746 292.697 119.062 297.728C120.378 302.759 125.425 305.744 130.335 304.395C135.244 303.046 138.157 297.874 136.841 292.843Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.659 82.2743H478.559C477.96 73.2569 471.66 73.1187 471.66 73.1187C471.66 73.1187 478.607 72.9741 478.607 62.5566C478.607 72.9747 485.557 73.1187 485.557 73.1187C485.557 73.1187 479.257 73.2569 478.659 82.2743Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.406 160.008V90.2849C122.406 83.3139 124.579 76.5252 128.609 70.9088C132.638 65.2924 138.313 61.142 144.806 59.0627L240.564 28.3934C246.763 26.4079 253.406 26.4079 259.605 28.3934L355.365 59.0627C361.858 61.142 367.533 65.2925 371.562 70.9089C375.591 76.5254 377.764 83.314 377.764 90.2849V160.008C377.764 193.302 367.849 225.803 349.344 253.169C330.838 280.534 304.624 301.46 274.204 313.15L255.688 320.265C252.075 321.653 248.093 321.653 244.48 320.265L225.963 313.15C195.544 301.46 169.33 280.534 150.825 253.168C132.32 225.803 122.406 193.302 122.406 160.008Z",
    fill: "#F66666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.259 190.052C246.133 190.052 242.175 188.372 239.257 185.381C236.339 182.391 234.699 178.335 234.699 174.106V108.255C234.699 106.16 235.102 104.087 235.884 102.152C236.666 100.218 237.812 98.4598 239.257 96.9791C240.702 95.4983 242.417 94.3238 244.305 93.5224C246.193 92.721 248.216 92.3086 250.259 92.3086C252.303 92.3086 254.326 92.721 256.214 93.5224C258.102 94.3238 259.817 95.4983 261.262 96.9791C262.707 98.4598 263.853 100.218 264.635 102.152C265.417 104.087 265.82 106.16 265.82 108.255V174.106C265.82 178.335 264.18 182.391 261.262 185.381C258.344 188.372 254.386 190.052 250.259 190.052Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.998 237.593C258.591 237.593 265.558 230.454 265.558 221.647C265.558 212.84 258.591 205.701 249.998 205.701C241.404 205.701 234.438 212.84 234.438 221.647C234.438 230.454 241.404 237.593 249.998 237.593Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 354,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorpagegraphic);
export default __webpack_public_path__ + "static/media/Error page graphic.41b32ae04fd5b5dba8178e4b599eace8.svg";
export { ForwardRef as ReactComponent };